// extracted by mini-css-extract-plugin
export default {"header":"ScrollTable_header__tDEBP","scrolled":"ScrollTable_scrolled__tDdFz"};